import React from 'react';
import { Button, Form, Input } from 'antd';
import { useAuth } from '../../context/AuthContext';
import { useUpdateProfileMutation } from '../../queries/settings';
import { Card, CardHead } from '../../components';

export default function ProfileCard() {
  const { user, updateUser } = useAuth();
  const { mutate, isPending } = useUpdateProfileMutation();

  const save = (values) => mutate(values, { onSuccess: (res) => updateUser(res.user) });

  return (
    <Card aria-labelledby="profile-title">
      <CardHead>
        <h2 id="profile-title">Your profile</h2>
        <span>{user?.email}</span>
      </CardHead>
      <Form
        layout="vertical"
        onFinish={save}
        requiredMark={false}
        initialValues={{ firstName: user?.firstName, lastName: user?.lastName, phoneNumber: user?.phoneNumber }}
      >
        <div style={{ display: 'flex', gap: 12 }}>
          <Form.Item name="firstName" label="First name" rules={[{ required: true, whitespace: true }]} style={{ flex: 1 }}>
            <Input autoComplete="given-name" />
          </Form.Item>
          <Form.Item name="lastName" label="Last name" rules={[{ required: true, whitespace: true }]} style={{ flex: 1 }}>
            <Input autoComplete="family-name" />
          </Form.Item>
        </div>
        <Form.Item name="phoneNumber" label="Phone">
          <Input autoComplete="tel" placeholder="+18175551234" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={isPending}>
          Save profile
        </Button>
      </Form>
    </Card>
  );
}
